import Rx from 'rx';
import { Store as UserStore, Actions as UserActions } from '../../modules/User';
import BaseStore from '../../BaseStore';
import * as CustomField from '../../modules/CustomField';
import { setCurrency } from '../../utils/Format';

import { List as ImmList } from 'immutable';
import {
    FETCH_CUSTOMFIELDS,
    STORE_CUSTOMFIELDS,
    GET_ORGANIZATION_TOKENS,
    SET_ORGANIZATION_TOKENS,
    GET_USER_PROFILE,
    SET_USER_PROFILE,
    GET_USER_ORGANIZATION,
    SET_USER_ORGANIZATION,
    FETCH_PARTITIONSETS,
    STORE_PARTITIONSETS,
} from './mutation-types';

let customFieldsDisposable!: Rx.Disposable;
let orgTokensDisposable!: Rx.Disposable;
let partitionSetsDisposable!: Rx.Disposable;

let userProfileDisposable: Rx.Disposable;
let userOrgDisposable: Rx.Disposable;

export default {
    [FETCH_PARTITIONSETS]: ({ state, commit }, { organization }) => {
        if (partitionSetsDisposable) {
            partitionSetsDisposable.dispose();
        }
        return new Promise((resolve, reject) => {
            if (state.partitionSets && state.partitionSets.length) {
                resolve(state.partitionSets);
                return;
            }
            partitionSetsDisposable = BaseStore.connection(organization)
                .authObservable()
                .first()
                .subscribe(() => {
                    const partitionSets = ImmList(BaseStore.connection(organization).authInfo.partitionSets);
                    commit(STORE_PARTITIONSETS, { partitionSets });
                    resolve(partitionSets);
                }, reject);
        });
    },
    [FETCH_CUSTOMFIELDS]: ({ state, commit }, { organization }) => {
        if (customFieldsDisposable) {
            customFieldsDisposable.dispose();
        }
        return new Promise((resolve, reject) => {
            if (state.customFields && state.customFields.length) {
                resolve(state.customFields);
                return;
            }
            customFieldsDisposable = CustomField.Store.getItems(organization, 'any')
                .first()
                .subscribe((response) => {
                    if (!response) {
                        throw new Error('Unable to fetch subscriber custom fields during this time');
                    }
                    const customFields = response.sort((a, b) =>
                        a.field.toUpperCase().localeCompare(b.field.toUpperCase())
                    );
                    commit(STORE_CUSTOMFIELDS, { customFields });
                    resolve(customFields);
                }, reject);
        });
    },
    [GET_USER_PROFILE]: ({ commit }) => {
        if (userProfileDisposable) {
            userProfileDisposable.dispose();
        }
        return new Promise((resolve, reject) => {
            userProfileDisposable = UserActions.getUserProfile().subscribe((response) => {
                commit(SET_USER_PROFILE, { user: response.result });
                resolve(response.result);
            }, reject);
        });
    },
    [GET_USER_ORGANIZATION]: ({ commit }, { org }) => {
        if (userOrgDisposable) {
            userOrgDisposable.dispose();
        }
        return new Promise((resolve, reject) => {
            userOrgDisposable = UserStore.session()
                .getOrgProfile(org)
                .first()
                .subscribe((response) => {
                    const organization = response.first();
                    if (typeof organization === 'undefined') {
                        reject(new Error(`Unable to access the organization ${org}`));
                        return;
                    }

                    // Update global organization settings
                    const currency = organization.getIn(['settings', 'currency']);
                    if (currency) {
                        setCurrency(currency);
                    }

                    commit(SET_USER_ORGANIZATION, { organization });
                    resolve(organization);
                }, reject);
        });
    },
    [GET_ORGANIZATION_TOKENS]: ({ commit }) => {
        if (orgTokensDisposable) {
            orgTokensDisposable.dispose();
        }

        return new Promise((resolve, reject) => {
            orgTokensDisposable = UserStore.session()
                .getOrganizations()
                .filter((tokens) => tokens.count() > 0)
                .first()
                .subscribe((tokens) => {
                    commit(SET_ORGANIZATION_TOKENS, { tokens });
                    resolve(tokens);
                }, reject);
        });
    },
};
